const api = 'https://beta.api.elevate.com.bd'

export default api